import React from 'react'
import { Link } from 'react-router-dom'
import { company } from '../data/company'
import './Footer.css'

const Footer = () => {
  const year = new Date().getFullYear()

  return (
    <footer className="site-footer">
      <div className="container footer-grid">
        <div className="footer-brand">
          <img src="/logo-on-dark.svg" alt="" className="footer-logo" width="140" height="107" />
          <p className="footer-tagline">
            Building FinQ and delivering product engineering services.
          </p>
        </div>

        <div className="footer-col">
          <h3 className="footer-heading">Company</h3>
          <ul className="footer-links">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/services">Services</Link>
            </li>
            <li>
              <a href="/#platform">Platform</a>
            </li>
            <li>
              <a href="/#contact">Contact</a>
            </li>
          </ul>
        </div>

        <div className="footer-col">
          <h3 className="footer-heading">Platform</h3>
          <ul className="footer-links">
            <li>
              <a href="https://finq.in" target="_blank" rel="noopener noreferrer">
                FinQ
              </a>
            </li>
            <li>
              <a href={`mailto:${company.email}`}>{company.email}</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <span>{company.legalName}</span>
          <span>CIN: {company.cin}</span>
          <span>&copy; {year} Konsri Technologies</span>
        </div>
      </div>
    </footer>
  )
}

export default Footer
